<template>
  <el-dialog
    :title="$t('common.confirmDelete')"
    :visible.sync="dialogVisible"
    width="500px"
    @close="handleClose"
  >
    <div class="delete-content">
      <p>{{ $t('housekeepingType.confirmDeleteContent') }}</p>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="confirmDelete">
        {{ $t('common.confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteHousekeepingType } from '@/api/housekeeping/housekeepingTypeApi'

export default {
  name: 'DeleteHousekeepingType',
  data() {
    return {
      dialogVisible: false,
      deleteInfo: {}
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.deleteInfo = { ...row }
    },
    handleClose() {
      this.deleteInfo = {}
    },
    async confirmDelete() {
      try {
        const res = await deleteHousekeepingType(this.deleteInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('common.submitSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('删除失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.delete-content {
  text-align: center;
  font-size: 16px;
  padding: 20px 0;
}
</style>